var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAsterisco = function SvgAsterisco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.88 12.274 3.281-.668.536-.176-.918-2.848-.536.175-3.084 1.425-1.673.8a1.579 1.579 0 0 0-.274-.198l.241-1.851.394-3.374V5H10.85v.559l.405 3.374.24 1.862c-.091.056-.179.118-.262.186l-1.684-.8-3.084-1.424-.536-.175L5 11.43l.536.176 3.335.668 1.837.34c.021.105.054.208.099.306l-1.28 1.359-2.307 2.497-.34.46L9.31 19l.328-.46 1.662-2.969.886-1.632h.328l.896 1.632 1.651 2.969.34.46 2.416-1.764-.328-.46-2.307-2.497-1.269-1.348c.043-.103.08-.21.11-.317l1.859-.34Z",
    fill: "currentColor"
  })));
};
export { SvgAsterisco as ReactComponent };
export default __webpack_public_path__ + "2f7d50e133b3f4f9f004da52733d6917.svg";